import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import biopictaIcon from 'assets/icons/biopicta.jpeg'
import geniusMindZoneIcon from 'assets/icons/genius_mind_zone.png'
import CorporateFareRoundedIcon from '@mui/icons-material/CorporateFareRounded'

const experiences = [
  {
    role: 'MERN Stack Developer',
    duration: 'Oct 2024 – Present',
    companyName: 'Genius Mind Zone',
    companyLink: 'https://geniusmindzone.com/',
    companyLogo: geniusMindZoneIcon,
    responsibilities: [
      'Developed and launched a TikTok affiliate marketing platform from scratch using MERN stack.',
      'Delivered Version 2 with enhanced performance, cleaner UI, and improved UX.',
      'Contributed to additional company projects ensuring timely delivery and code quality.',
    ],
  },
  {
    role: 'Full Stack Developer',
    duration: 'Dec 2023 – Sep 2024',
    companyName: 'Remote Job',
    companyLink: null,
    companyLogo: null,
    responsibilities: [
      'Optimized web app performance and reduced load times.',
      'Regularly updated mobile apps and web-based admin panels.',
      'Fixed bugs and maintained updates to improve stability.',
    ],
  },
  {
    role: 'Frontend Developer Intern',
    duration: 'Sep 2023 – Nov 2023',
    companyName: 'Biopicta (Pvt. Ltd.)',
    companyLink: 'https://biopicta.com/',
    companyLogo: biopictaIcon,
    responsibilities: [
      'Optimized website performance across key pages.',
      'Collaborated with design and backend teams on feature delivery.',
      'Identified and resolved frontend bugs for a seamless UX.',
      'Implemented responsive design patterns for cross-device compatibility.',
    ],
  },
]

export default function Experience() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Usman Arif | Experience</title>
        <meta name="description" content="Muhammad Usman Arif | Professional Experience" />
        <meta name="keywords" content="usmanarif, Muhammad Usman Arif, experience, MERN Stack" />
      </Helmet>

      <div id="experience-section" data-aos="fade-right">
        <div className="section-heading">
          <span className="section-tag">My Journey</span>
          <h2>Work <span className="gradient-text">Experience</span></h2>
          <div className="heading-bar" />
        </div>

        <div className="exp-timeline pb-3 pb-md-4">
          {experiences.map((exp, i) => (
            <div className="exp-item" key={i}>
              <div className="exp-dot" />
              <div className="exp-card">
                <div className="exp-header">
                  <h5 className="exp-role">{exp.role}</h5>
                  <span className="exp-duration">{exp.duration}</span>
                </div>

                <div className="exp-company">
                  {exp.companyLogo ? (
                    <img
                      src={exp.companyLogo}
                      alt={exp.companyName}
                      className="company-logo"
                    />
                  ) : (
                    <div className="company-icon">
                      <CorporateFareRoundedIcon />
                    </div>
                  )}
                  {exp.companyLink ? (
                    <Link to={exp.companyLink} target="_blank">
                      {exp.companyName}
                    </Link>
                  ) : (
                    <span style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--accent-light)' }}>
                      {exp.companyName}
                    </span>
                  )}
                </div>

                <p className="exp-responsibilities">Responsibilities</p>
                <ul>
                  {exp.responsibilities.map((r, j) => (
                    <li key={j}>{r}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
